(function ($) {
    var defaults = {
        url: "https://api.ultrapassport.net",
        suffix: "",
        token_name: "token"
    };

    var settings = $.extend({}, defaults);

    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        } else {
            var expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }

    function addAuth(xhr) {
        var token = readCookie('passport_token');
        if (token) {
            xhr.setRequestHeader('Authorization', 'passport_token ' + token);
        }
    }

    function getParameterByName(name, url) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    window.passport = {
        configure: function (options) {
            settings = $.extend({}, defaults, options);
            if(settings.token_name) {
                var token = getParameterByName(settings.token_name);
                if(token) {
                    createCookie('passport_token', token, 365);
                }
            }
        },
        login: function (email, password) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/token' + settings.suffix,
                type: 'POST', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify({'email': email, 'password': password})
            })
            .done(function (data, textStatus, jqXHR) {
                var token = data.token;
                createCookie('passport_token', token, 365);
            });
        },
        logout: function () {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/token' + settings.suffix,
                type: 'DELETE', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                beforeSend: addAuth
            });
        },
        info: function () {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me' + settings.suffix,
                type: 'GET', dataType: 'json',
                xhrFields: {withCredentials: true},
                beforeSend: addAuth
            });
        },
        create: function (data,locale) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me' + settings.suffix,
                type: 'POST', contentType: 'application/json', dataType: 'json',
                data: JSON.stringify($.extend(data, {'locale': locale})),
                beforeSend: addAuth
            });
        },
        update: function (data, url, locale) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me' + settings.suffix,
                type: 'PUT', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify($.extend(data, {'url': url, 'locale': locale})),
                beforeSend: addAuth
            });
        },
        delete: function () {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me' + settings.suffix,
                type: 'DELETE', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                beforeSend: addAuth
            });
        },
        subscriptions: function () {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me/subscription' + settings.suffix,
                type: 'GET', dataType: 'json',
                xhrFields: {withCredentials: true},
                beforeSend: addAuth
            });
        },
        subscribe: function (code) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me/subscription/' + code + settings.suffix,
                type: 'PUT', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify({}),
                beforeSend: addAuth
            });
        },
        unsubscribe: function (code) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me/subscription/' + code + settings.suffix,
                type: 'DELETE', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                beforeSend: addAuth
            });
        },
        registrations: function () {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me/registration' + settings.suffix,
                type: 'GET', dataType: 'json',
                xhrFields: {withCredentials: true},
                beforeSend: addAuth
            });
        },
        register: function (code, extra) {
            if (extra === undefined) {
                extra = {};
            }
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me/registration/' + code + settings.suffix,
                type: 'PUT', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify(extra),
                beforeSend: addAuth
            });
        },
        unregister: function (code) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me/registration/' + code + settings.suffix,
                type: 'DELETE', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify({}),
                beforeSend: addAuth
            });
        },
        estimate: function (event, instance) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/estimate/' + event + '/' + instance + settings.suffix,
                type: 'GET', dataType: 'json',
                xhrFields: {withCredentials: true},
                beforeSend: addAuth
            });
        },
        activateWristband: function (wristband_id, serial) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/get_token/wristband/activate' + settings.suffix,
                type: 'POST', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify({external_id: wristband_id+serial}),
                beforeSend: addAuth
            });
        },
        checkFrontGateRegistration: function (event, instance, lookup_id) {
            return grecaptcha.ready(() => {
                return grecaptcha.execute(recaptcha_site_key, {action: 'front_gate_registration/registration/check'}).then((token) => {
                    return $.ajax({
                        url: settings.url.replace(/\/+$/, "") + '/front_gate_tickets/registration/check' + settings.suffix,
                        type: 'POST', contentType: 'application/json', dataType: 'json',
                        xhrFields: {withCredentials: true},
                        data: JSON.stringify({event: event, instance: instance, lookup_id: lookup_id}),
                        beforeSend: function (xhr) {
                            addAuth(xhr);
                            xhr.setRequestHeader('X-Recaptcha-Token', token);
                        }
                    });
                });
            });
        },
        activateFrontGateRegistration: function (event, instance, lookup_id) {
            let result = new Promise((resolve, reject) => {
                grecaptcha.ready(() =>
                    grecaptcha.execute(recaptcha_site_key, { action: 'front_gate_registration/registration/activate' }).then(token => {
                            resolve(token);
                        },
                        reject)
                );
            }).then((token) =>
                $.ajax({
                    url: settings.url.replace(/\/+$/, "") + '/front_gate_tickets/registration/activate' + settings.suffix,
                    type: 'POST', contentType: 'application/json', dataType: 'json',
                    xhrFields: {withCredentials: true},
                    data: JSON.stringify({event: event, instance: instance, lookup_id: lookup_id}),
                    beforeSend: function (xhr) {
                        addAuth(xhr);
                        xhr.setRequestHeader('X-Recaptcha-Token', token);
                    }
                })
            );

            return result;
        },
        generateZohoDeskToken: function (service_url) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/zoho_desk/token' + settings.suffix,
                type: 'POST', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify({'service_url': service_url}),
                beforeSend: addAuth
            });
        },
        sendVerify: function (url, locale) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me/verify' + settings.suffix,
                type: 'POST', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify({'url': url}),
                beforeSend: addAuth
            });
        },
        processVerify: function (token, email, url, locale) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me/verify/' + token + settings.suffix,
                type: 'POST', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify({'email': email, 'url': url}),
                beforeSend: addAuth
            }).done(function (data, textStatus, jqXHR) {
                createCookie(data.scheme, data.token, 365);
            });
        },
        processChangeEmail: function (token, email, url, locale) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/me/change_email/' + token + settings.suffix,
                type: 'POST', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify({'email': email, 'url': url, 'locale': locale}),
                beforeSend: addAuth
            });
        },
        sendReset: function (email, url, failUrl, locale) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/reset' + settings.suffix,
                type: 'POST', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify({'email': email, 'url': url, 'failUrl': failUrl}),
                beforeSend: addAuth
            });
        },
        processReset: function (token, email, password, url, locale) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/passport/reset/' + token + settings.suffix,
                type: 'POST', contentType: 'application/json', dataType: 'json',
                xhrFields: {withCredentials: true},
                data: JSON.stringify({'password': password, 'url': url}),
                beforeSend: addAuth
            }).done(function (data, textStatus, jqXHR) {
                createCookie(data.scheme, data.token, 365);
            });
        },
        sendLead: function (email, lastName, firstName, leadSource) {
            return $.ajax({
                url: settings.url.replace(/\/+$/, "") + '/lead' + settings.suffix,
                type: 'POST', contentType: 'application/json', dataType: 'json',
                //xhrFields: {withCredentials: true},
                data: JSON.stringify({
                    'Email': email,
                    'LastName': lastName,
                    'FirstName': firstName,
                    'LeadSource': leadSource
                }),
                //beforeSend: addAuth
            });
        }
    };
})(jQuery);
